import { createFileRoute } from '@tanstack/react-router';

import { SupplierPaymentsPage } from '@/features/supplier/payments-page';

export const Route = createFileRoute('/_app/supplier/$orgId/payments')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierPaymentsPage {...params} />;
}
